import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-sport-country-avatars',
    templateUrl: './sport-country-avatars.component.html',
    styleUrls: ['./sport-country-avatars.component.scss'],
    standalone: true,
    imports: [NgClass],
})
export class SportCountryAvatarsComponent {
  @Input() sportName!: string;
  @Input() countryCode!: string;
  @Input() isResponsiveMapList: boolean = false;

  constructor() {}
}
